import { ColorsType } from '../types'

const choices = {
    transparent: 'transparent',
    black: '#000',
    white: '#fff',
    red: '#E6001E',
    darkRed: '#b60920',
    stormGrey: '#737480',
    tundora: '#4d4d4d',
    charade: '#292A33',
    midGray: '#696A70',
    alto: '#dfdfdf',
    turbo: '#FBE400',
    greyMarble: '#ccc',
    boxShadow: '#0000001',
    seashell: '#f1f1f1',
    toreaBay: '#162EA6',
    resolutionBlue: '#002482',
    blueRibbon: '#2e49fe',
    piper: '#CF5226',
    piperDark: '#A5421E',
    blazeOrange: '#FF670A',
    chillOrange: '#e7a893',
    endeavour: '#0058AD',
    endeavourDark: '#003E79',
    azureRadiance: '#0777E5',
    chillEndeavour: '#80abd6',
    kashmirBlue: '#48639A',
    pickledBluewood: '#262F4B',
    pickledBluewoodDark: '#1B2135',
    chillPickledBluewood: '#9397a5',
    tokyoBlue: '#3e76ec',
    tokyoGreen: '#0c5055',
    tokyoYellow: '#fbf200',
    happeningBlue: '#0a3ac1',
    lifestylePink: '#B04AE3',
    entertainmentPurple: '#A8328B',
    latestRed: '#FF0505',
    defaultRed: '#BF001F',
}

export const colors: ColorsType = {
    brand: choices.red,
    section: choices.red,
    background: choices.white,
    text: {
        primary: {
            default: choices.charade,
            onDark: choices.white,
        },
        secondary: {
            default: choices.charade,
            onDark: choices.white,
        },
        heading: {
            default: choices.charade,
            onDark: choices.white,
        },
    },
    actions: {
        link: {
            default: choices.charade,
            hover: choices.darkRed,
            focus: choices.darkRed,
            active: choices.darkRed,
            onDark: {
                default: choices.white,
                hover: choices.white,
                focus: choices.white,
                active: choices.white,
            },
        },
        button: {
            text: {
                default: choices.white,
                hover: choices.white,
                focus: choices.white,
                active: choices.white,
                onDark: {
                    default: choices.white,
                    hover: choices.white,
                    focus: choices.white,
                    active: choices.white,
                },
            },
            background: {
                default: choices.red,
                hover: choices.black,
                focus: choices.black,
                active: choices.black,
                onDark: {
                    default: choices.red,
                    hover: choices.black,
                    focus: choices.black,
                    active: choices.black,
                },
            },
            border: {
                default: choices.red,
                onDark: choices.red,
            },
        },
    },
}
